import { BROADCAST_GET_GLOBAL_BANNER_TEMPLATES } from 'actions/Types';

export default () => {
  return dispatch => {
    const action = {
      type: BROADCAST_GET_GLOBAL_BANNER_TEMPLATES,
      request: async apiClient => {
        const { items } = await apiClient.broadcastBannerTemplate.getGlobal();

        return items;
      }
    };

    dispatch(action);
  };
};
